export default function isObjectEmpty(objectName: Record<string, unknown>): boolean {
  return Boolean(!objectName || (objectName && Object.keys(objectName).length === 0 && objectName.constructor === Object))
}
